import { render, staticRenderFns } from "./BonusesInPackagesByBenefit.vue?vue&type=template&id=59663d99&scoped=true&"
import script from "./BonusesInPackagesByBenefit.vue?vue&type=script&lang=js&"
export * from "./BonusesInPackagesByBenefit.vue?vue&type=script&lang=js&"
import style0 from "./BonusesInPackagesByBenefit.vue?vue&type=style&index=0&id=59663d99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59663d99",
  null
  
)

export default component.exports